export function getCache(key: string | null) {
  return JSON.parse(localStorage.getItem(`wowzi:${key}`) ?? 'null');
}

export function setCache(key: any, val: any | null) {
  if (!val) return localStorage.removeItem(`wowzi:${key}`);
  return localStorage.setItem(`wowzi:${key}`, JSON.stringify(val));
}
